import React, { useContext, useEffect, useState } from 'react';

import DropFileComponent from './DropFileComponent';

import * as lodash from 'lodash';
// import Excel from 'exceljs';
import XlsxPopulate, { fromFileAsync } from 'xlsx-populate';
import * as fs from 'file-saver';

import * as dataManager from '../adapters/data';

import { Spreadsheet } from 'react-spreadsheet';
import ReactDataSheet from 'react-datasheet';
import { forEach, update } from 'lodash-es';
import { GlobalContext } from '../contexts/GlobalContext';

import { Button } from 'semantic-ui-react';
import styled from 'styled-components';

import {
    DataSheetGrid,
    checkboxColumn,
    textColumn,
    keyColumn,
  } from 'react-datasheet-grid';



const SelectableCell = ({ cell, onSelect}) => {

}


const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 110px;
    padding-bottom: 60px;
    margin-left: 60px;
    margin-right: 60px;

    @media screen and (max-width: 425px) {
        margin-left: 19px;
        margin-right: 19px;
    }
`;


const FixedDiv = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 9999;
`;




const SchedulesPage = (props) => {
    const [data, setData] = useState([]);
    const [log, setLog] = useState([]);

    const [context, setContext] = useContext(GlobalContext);


    const handleDrop = (files) => {
        let fileType = files[0].name.split('.').pop();
        console.log(files[0]);
        

        switch (fileType) {
            case 'xlsx':
                loadExcel(files[0]);
                setContext( (prev) => {
                    return {...prev, showDropFileComponent: false}
                });
                break;
            case 'txt':
            case 'template':
                loadScheduleTemplate(files[0]);
                setContext( (prev) => {
                    return {...prev, showDropFileComponent: false}
                });
                break;
            default:
                console.log(`Could not load file. ${fileType} not supported`);

        }

    }

    const generateEntry = (index) => {
        console.log(index);
        return {value: index}
    }

    const loadExcel = async (file) => {

        const reader = new FileReader();
        XlsxPopulate.fromDataAsync(file)
        .then( (wb) => {

            console.log(wb, ' - workbook instance');
            let rowsArray = [];

            let sheets = wb.sheets();
            console.log(sheets);

            let values = wb.sheet(0).usedRange().value();
            // console.log(`Values: ${values[0][0]}`);

            for (let i = 0; i < values.length; i++) {
                console.log(`array length - ${values.length}`);
                let colsArray = [];
                for (let j = 0; j < values[i].length; j++) {
                    colsArray.push({value: values[i][j]});
                    console.log(`colsArray - values[${i}][${j}]: ${values[i][j]}`);
                }
                rowsArray.push(colsArray);
                console.log(`rowsArray: ${rowsArray}`);
            }
            setData(rowsArray);

        });


/// LOAD VIA EXCELJS
        // const wb = new Excel.Workbook();
        // const reader = new FileReader()

        // reader.readAsArrayBuffer(file)
        // reader.onload = () => {
        //     const buffer = reader.result;
        //     wb.xlsx.load(buffer).then(workbook => {

        //         //save 
        //         // wb.xlsx.writeBuffer().then( (data) => {
        //         //     let blob = new Blob([data]);
        //         //     fs.saveAs(blob, 'test2.xlsx');
        //         // });

        //         console.log(workbook, 'workbook instance')
        //         let arr2 = [];
        //         workbook.eachSheet((sheet, id) => {
                    

        //             sheet.eachRow((row, rowIndex) => {
        //                 console.log(row.values, rowIndex)
        //                 let arr = [];
                        
        //                 // forEach(row.values, (v) => {
        //                 //     arr = [...arr, {value: v}];
        //                 // }) 

        //                 // arr2 = [...arr2, arr];
        //                 // console.log(arr2);

        //                 // setData([...data, arr]);
                        
        //                 // setData([row.values.map( (e) => { return {value: e} })]);
        //                 // console.log(data)
        //                 // setData([...data, row.values.map( (e) => {
        //                 //     return {value: e}
        //                 // })]);

        //                 setData( (prevData) => [...prevData, row.values.map( (e) => { return {value: e} })]);

        //                 // setContext( (prev) => { return {...prev, showDropFileComponent: false} })
        //             });


        //         })
                
        //     });
        // }
/// END OF LOAD VIA EXCELJS


    }

    const setPositionCell = (selectedCells) => {

        console.log('Postion set');


        context['selectedCells'].map( (e) => {

            //ensure cell doesn't already exist in array.
            if ( context['positionCells']?.find( (f) => {
                return (f.column === e.column && f.row === e.row);
            }) === undefined ) {
                // add selected cell(s) to positionCells
                setContext( (prevContext) => { //set positionCells to selectionCells
                    return {...prevContext, positionCells: [...prevContext['positionCells'], e]}
                } );
            }
            else {
                // don't add because it already exists in the positionCells array
            }


            
        });
    }

    const unsetPositionCell = (selectedCells) => {
        console.log('Unset position cell');


        context['selectedCells'].map( (e) => {

            //ensure cell exists in array.
            if ( context['positionCells']?.find( (f) => {
                return (f.column === e.column && f.row === e.row);
            }) === undefined ) {
                // don't remove because it doesn't exist in the positionCells array
            }
            else {
                // remove selected cell(s) from positionCells
                setContext( (prevContext) => { //unset positionCells to selectionCells
                    return {...prevContext, positionCells: [...prevContext['positionCells'].filter( (f) => {
                        // console.log('iterate:  ', f);
                        // console.log('remove', e);
                        console.log('iterate: ', f.row, f.column)
                        return (f.row !== e.row || f.column !== e.column)
                    })]}
                } );
            }
            
        });
    }

    const loadScheduleTemplate = (file) => {
        console.log('LOAD SCHEDULE TEMPLATE - ' );
        let fileReader = new FileReader();
        let jsonArray = null;
        fileReader.onload = (e) => {
            jsonArray = JSON.parse(e.target.result);
            console.log(jsonArray);
            setData(jsonArray.data);
            setContext( (prevContext) => {
                return {...prevContext, positionCells: jsonArray.positionCells}
            } );
        }
        fileReader.readAsText(file);
    }

    const saveScheduleTemplate = (sheet, positionCells, filename ='template.txt') => {
        console.log('SAVE SCHEDULE TEMPLATE - ' );
        console.log(sheet);
        console.log(positionCells);


        // let output = {
        //     data: sheet.map( (e) => {
        //         return e.map( (f, i) => {
        //             console.log('f: ', f, i);
        //             if (f !== null) {
        //                 return f
        //             }
        //             else {
        //                 return {value: ''};
        //             }
        //         })
        //     }),
        //     positionCells: positionCells
        // }
        // console.log('output: ', output);


        let dataArray = [];
        let dataElement = null;
        let dataRow = [];
        for (var i = 0; i < sheet.length; i++) {
            for (var j = 0; j < sheet[i].length; j++) {
                if (sheet[i][j] === null || sheet[i][j] === undefined) {
                    console.log('test: ', sheet[i][j]);
                    dataElement = {value: ''};
                }
                else {
                    dataElement = sheet[i][j];
                }
                dataRow.push(dataElement);
            }
            dataArray.push(dataRow);
            dataRow = [];
        }
        let output = {
            data: dataArray,
            positionCells: positionCells
        }
        console.log(`output: ${JSON.stringify(output)}`);        
        
        var blob = new Blob([JSON.stringify(output)], {type: "application/json;charset=utf-8"});
        fs.saveAs(blob, filename);
    }

    const generateSchedule = () => {
        console.log('Generating schedule');

        let e = lodash.cloneDeep(context['employees']);
        e.sort( () => Math.random() - 0.5);
        let p = context['positions'];
        p.sort( () => Math.random() - 0.5);
        let filled = false;
        let tempSchedule = [];
        setLog([]);


        for (let i = 0; i < p.length; i++) {
            filled = false;
            for (let j = 0; j < e.length; j++) {

                if ( p[i].qualifications.every(posQual => e[j].qualifications.some( (q) => q.name === posQual.name)) ) {

                    if (e[j].placed == null) {
                        console.log('employee '+ e[j].name + ' is qualified for ' + p[i].name);
                        setLog( (prevLog) => {return [...prevLog, 'employee '+ e[j].name + ' is qualified for ' + p[i].name ] });
                        tempSchedule.push( {position: p[i], employee: e[j]});
                        filled = true;
                        e[j].placed = true;
                        break;
                    }
                }
                else {
                    console.log('employee ' + e[j].name + ' is not qualified for ' + p[i].name);
                    setLog( (prevLog) => {return [...prevLog, 'employee ' + e[j].name + ' is not qualified for ' + p[i].name ] });
                }

            }

            if (filled === false) {
                tempSchedule.push( {position: p[i], employee: null });
                console.log('Position ' + p[i].name + ' could not be filled.');
                setLog( (prevLog) => {return [...prevLog, 'Position ' + p[i].name + ' could not be filled.' ] });
                
            }
        }

        setContext( prevContext => {

            dataManager.saveState( {
                ...prevContext, 
                schedule: tempSchedule
            });

            return {
                ...prevContext, 
                schedule: tempSchedule

            }
        });



        updateSheetWithGeneratedSchedule(tempSchedule);

        console.log('Schedule Generated.');
        //console.log(tempSchedule);
        // toggleGeneragedScheduleModal();
    }

    const updateSheetWithGeneratedSchedule = (schedule) => {
        
        console.log('GENERATED SCHEDULE - ', schedule);
        console.log(data);


        for (let i = 0; i < data.length; i++) { //loop through each row
            for (let j = 0; j < data[i].length; j++) { //loop through each column
                console.log(data[i][j]);

                for (let k = 0; k < context['positionCells'].length; k++) {

                    if (context['positionCells'][k]['position']) { // cell is marked 'position'
                        for (let m = 0; m < schedule.length; m++) { //loop through generated schedule array
                            
                            if (context['positionCells'][k]['column'] === j && context['positionCells'][k]['row'] === i  
                                && schedule[m]['position'].name === context['positionCells'][k]['position']) {

                                // console.log('Scedule Pos: ', schedule[m]['position'].name);
                                // console.log('PositionCell Pos: ', context['positionCells'][k]['position']);
                                // console.log('Row: ', context['positionCells'][k]['row']);
                                // console.log('Col: ', context['positionCells'][k]['column']);
                                // console.log('Position: ', context['positionCells'][k]['position']);

                                let arr = [...data];
                                arr[i][j] = {value: schedule[m]['employee']?.name || ''};
                                setData(arr);

                            }
                        }
                    }
                }

                if (data[i][j] === undefined) {

                }
                else {

                }
            }
        }
    }

    const clearSheet = () => {
        setContext( (prev) => {
            return {...prev, showDropFileComponent: true}
        });
        setData([]);
    }

    return (
        props.active === 'schedules' ? (
        <React.Fragment>
            <div>

            <HeaderDiv>
                {/* <HeaderText>{ context['employees'] ? context['employees'].length : 0 } Employees</HeaderText>
                <AddEmployeeButton onClick={props.addEmployeeCb}>Add Employee</AddEmployeeButton> */}
                {/* <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <HeaderText>View as {viewMode}</HeaderText>
                    <ViewAsToggleComponent handleClick={handleViewMode} />
                </div> */}
            </HeaderDiv>

                <DropFileComponent handleDrop={handleDrop} show={(data === null || data === undefined || data.length == 0)}>
                    Drag spreadsheet file here
                </DropFileComponent>


                {/* <DataSheetGrid 
                    data={data}
                    columns = { columns }
                    
                /> */}

                {
                    data === null || data === undefined || data.length == 0 ? '' :

                    <div>
                        <Button onClick={clearSheet }>Clear Sheet</Button>
                        <Button onClick={props.setPositionCellCb }>Set Selected Cells to Position</Button>
                        <Button onClick={unsetPositionCell}>Reset Selected Cells</Button>
                        <Button onClick={() => {saveScheduleTemplate(data, context['positionCells'])}}>Save Schedule Template</Button>
                        <Button onClick={generateSchedule}>Generate Schedule</Button><br />

                        <div style={{padding: 15}}>
                            <Spreadsheet 
                                data={data} 
                                onSelect={ (selected)=> {
                                    // Set selected cells to 'POSITION CELLS'
                                    setContext( (prevContext) => {
                                        return {...prevContext, selectedCells: selected}
                                    } );


                                    // if (selected?.length > 0) {
                                    //     selected.map( (e) => {
                                    //         console.log(JSON.stringify(data[e.row][e.column]));
                                    //     });
                                    // }
                                    // console.log(`Selection: ${JSON.stringify(selected)}`);
                                    // console.log(`Value: ${JSON.stringify(data[selected[0].row][selected[0].column])}`)
                                }} 

                            />
                        </div>
                    </div>
                }

                {
                    log.map((item, i) => {
                        return <li key={i}>{item}</li>
                    })
                }

                {/* <ReactDataSheet
                    data={data}
                    valueRenderer={(cell) => { 
                        console.log(cell);
                        if (typeof cell.value === 'object') {
                            return (<a href={`${cell.value.hyperlink}`}>{cell.value.text}</a>);
                        }
                        return cell.value
                    }}
                    onCellsChanged={changes => {
                    const grid = this.state.grid.map(row => [...row]);
                    changes.forEach(({ cell, row, col, value }) => {
                        grid[row][col] = { ...grid[row][col], value };
                    });
                    //this.setState({ grid });
                    }}
                /> */}
            </div>
        </React.Fragment>
        )
        : 
        <React.Fragment>
            
        </React.Fragment>
    );
};

export default SchedulesPage;